import React from 'react';
import { senderEmail } from '../lenders';

/** Lender name over the sender address; in a lender card (compact) the sender only. Addresses never wrap.
 *  `extra` renders a small tag below the address (e.g. "From one email"). */
export const WhoCell: React.FC<{ sender: string; lender: string | null; compact?: boolean; extra?: React.ReactNode }> = ({
  sender, lender, compact, extra,
}) => {
  const address = senderEmail(sender);
  if (compact || !lender) {
    return <div className="cur-who"><strong className="cur-ellip" title={address} style={{ fontWeight: 500 }}>{address}</strong>{extra}</div>;
  }
  return (
    <div className="cur-who">
      <strong title={lender}>{lender}</strong>
      <span className="cur-ellip" title={address}>{address}</span>
      {extra}
    </div>
  );
};
